import React from "react";
import PropTypes from "prop-types";
import { LimitsHint, StakeColumn } from "./elements";

export const BettoStakeFieldLayout = ({ stakeField, limits }) => (
	<StakeColumn>
		{stakeField}
		<LimitsHint>{limits}</LimitsHint>
	</StakeColumn>
);

BettoStakeFieldLayout.propTypes = {
	stakeField: PropTypes.node.isRequired,
	limits: PropTypes.node,
};

BettoStakeFieldLayout.defaultProps = {
	limits: null,
};
